if (!customElements.get('tsp-print-files')) {
  customElements.define('tsp-print-files', class extends HTMLElement {
    connectedCallback() {
      this.productRoot = this.closest('product-info') || this.closest('section');
      this.productForm = this.closest('form');
      this.onOptionChange = () => this.syncPositions();
      this.productRoot?.addEventListener('change', this.onOptionChange, true);
      this.propertyObserver = new MutationObserver(this.onOptionChange);
      if (this.productForm) this.propertyObserver.observe(this.productForm, {childList: true, subtree: true});
      this.syncPositions();
    }
    disconnectedCallback() {
      this.productRoot?.removeEventListener('change', this.onOptionChange, true);
      this.propertyObserver?.disconnect();
    }
    syncPositions() {
      const picker = this.productRoot?.querySelector('variant-selects');
      const lastOption = Array.from(picker?.querySelectorAll('fieldset, select') || []).at(-1);
      const selectedPrint = lastOption?.tagName === 'SELECT'
        ? lastOption.value
        : lastOption?.querySelector('input:checked')?.value;
      const print = selectedPrint || this.dataset.print;
      const positions = {
        'Full color fronte': ['front'],
        'Full color retro': ['back'],
        'Solo lato cuore': ['heart'],
        'Full color fronte e retro': ['front', 'back'],
        'Lato cuore e full color retro': ['heart', 'back']
      }[print] || [];
      for (const fieldset of this.querySelectorAll('[data-print-position]')) {
        const active = positions.includes(fieldset.dataset.printPosition);
        fieldset.hidden = !active;
        fieldset.disabled = !active;
      }
      const fileProperties = {
        'properties[File fronte]': 'front',
        'properties[File retro]': 'back',
        'properties[File lato cuore]': 'heart'
      };
      for (const input of this.productForm?.querySelectorAll('input[name]') || []) {
        if (fileProperties[input.name]) input.disabled = !positions.includes(fileProperties[input.name]);
      }
    }
  });
}
